<template>
  <div>

    <div
      v-if="this.appList && this.appList.length > 0"
      class="columns is-multiline page-integrations__cols"
    >
      <div
        v-for="app in this.appList"
        :key="app.id"
        :value="app.id"
        class="app-card">
        <app-card :app="app" />
      </div>
    </div>

    <div v-else class="column">
      <empty-app-list />
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import AppCard from "./app-card/AppCard.vue";
import EmptyAppList from "./empty-app-list/EmptyAppList.vue";

const { mapState } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-app-list",

  computed: {
    ...mapState(["appList"]),
  },

  components: {
    AppCard,
    EmptyAppList,
  },

};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {

  .app-card{
    align-items: stretch;
    min-width: 290px;
    width: 210px;
    padding: 0.5rem;
  }

  &__cols {
    padding: 0.5rem;
  }

  &__col {
    width: 100px;
    padding: 0.5rem;
  }

  &__description {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-bottom: 1rem;
  }

  &__notification {
    &--is-warning {
      font-size: 1.4rem;
      background-color: transparent;
      color: #767676;

      .icon {
        margin-right: 1.6rem;
        position: relative;
        top: 4px;
        font-size: 1.6rem;
      }
    }
  }

  &__icon {
    cursor: help;

    &--success {
      color: $primary;
    }

    &--danger {
      color: $danger;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-list/AppList.vue